import { combineReducers } from 'redux';

import { aggregatedActivityReducer } from './aggregatedActivity';
import { calculatedInternalReducer } from './calculatedInternal';
import { employeeHourReducer } from './employeeHour';
import { forecastReducer } from './forecast';
import { internalHourReducer } from './internalHour';

const aggregatedReducers = combineReducers({
  employeeHour: employeeHourReducer,
  aggregatedActivity: aggregatedActivityReducer,
  forecast: forecastReducer,
  calculatedInternal: calculatedInternalReducer,
  internalHour: internalHourReducer,
});

export default aggregatedReducers;
